/** The server's own reason, where it gave one.
 *
 *  A dialog that swallows a 400's detail and prints its own generic sentence
 *  is one that hides the answer — "no CRM contact is behind this party" tells a
 *  reader what to do next, and "could not be saved" does not.
 */
export function detailOf(failure: unknown, fallback: string): string {
  const detail = (failure as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail
  return typeof detail === 'string' ? detail : fallback
}
